var React = require('react');

function ArrowLeftCircle (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"50","height":"50","x":"50","y":"50.5","opacity":".1","rx":"25","transform":"rotate(180 50 50.5)","key":0}),React.createElement("path",{"d":"m16.492 24.587 7.031-7.031a.586.586 0 0 1 .828.828l-6.03 6.031h15.772a.586.586 0 1 1 0 1.172H18.321l6.03 6.031a.586.586 0 0 1-.828.828l-7.031-7.03a.586.586 0 0 1 0-.829z","key":1})]);
}

ArrowLeftCircle.defaultProps = {"width":"50","height":"51"};

module.exports = ArrowLeftCircle;

ArrowLeftCircle.default = ArrowLeftCircle;
